/* global Ps */
Wee.fn.extend('identoMap', {
	initLocations: function() {
		var priv = this.$private;

		priv.initLocationApps();
		priv.bindLocations();

		if ($.screen.size() > 2) {
			Ps.initialize($('ref:mapLocations')[0]);
			priv.initScrollbarListener();
		}
	},
	unloadLocations: function() {
		$.events.off(false, '.mapLocations');

		$._doc.removeEventListener('ps-scroll-y', function() {
			scope.scrolled = false;
		});

		if (typeof Ps != 'undefined') {
			Ps.destroy($('ref:mapLocations')[0]);
		}

		clearInterval(this.$private.interval);
	}
}, {
	/**
	 * Init locations app
	 *
	 * @private
	 */
	initLocationApps: function() {
		this.stateApp = $.app.make('mapState', {
			target: 'ref:mapState',
			view: 'idento-map.state',
			model: ''
		});

		this.locationsApp = $.app.make('mapLocations', {
			target: 'ref:mapLocations',
			view: 'idento-map.locations',
			model: {
				desktop: null,
				locations: {},
				state: {}
			}
		});
	},

	/**
	 * Update locations
	 *
	 * @private
	 * @param {object} data
	 */
	updateLocations: function(data) {
		var state = data.state,
			desktop = $.screen.size() > 2,
			locations = desktop ? this.markers._layers : data.locations;

		this.stateApp.$set(state);

		this.locationsApp.$set({
			desktop: desktop,
			locations: locations,
			state: state
		});

		$.history.bind({
			click: $('ref:mapLocationApptLink')
		});

		if ($.screen.size() > 2) {
			this.scrollToTop(0);

			Ps.update($('ref:mapLocations')[0]);
		}
	},

	/**
	 * Bind location events
	 *
	 * @private
	 */
	bindLocations: function() {
		var scope = this,
			app = scope.locationsApp;

		$.events.on({
			'ref:mapLocationToggle': {
				click: function(e, el) {
					scope.highlightLocation(
						$(el).closest('ref:mapLocation').data('id')
					);

					if ($.screen.size() > 2) {
						scope.panMap();
					}
				}
			},
			'ref:mapLocationDirections': {
				click: function(e) {
					var feature = app.$get(
						'locations.' + app.$get('active') +
						($.screen.size() > 2 ? '.feature' : '') +
						'.properties.info'
					);

					$('ref:mapDisclaimer').show();

					// Update Google directions link
					$('ref:mapDisclaimerDirections').attr('href',
						$.view.render(
							'https://maps.google.com?daddr={{ address }}+' +
							'{{ city }}+{{ state }}+{{ zip }}',
							feature
						)
					);

					e.stopPropagation();
				}
			}
		}, {
			delegate: 'ref:mapLocations',
			namespace: 'mapLocations'
		});

		// Stop directions popup from closing on clicking within itself
		$('ref:mapDisclaimer').on('click.mapLocations', function(e) {
			e.stopPropagation();
		});

		// Close direction popup
		$($._doc).add('ref:mapDisclaimerClose').on('click.mapLocations', function() {
			$('ref:mapDisclaimer').hide();
		});
	},

	/**
	 * Init scrollbar listener
	 *
	 * @private
	 */
	initScrollbarListener: function() {
		var scope = this;

		scope.scrolled = false;

		$._doc.addEventListener('ps-scroll-y', function() {
			scope.scrolled = true;
		});

		scope.interval = setInterval(function() {
			var $locations = $('ref:mapLocations');

			if (scope.scrolled) {
				var $sidebar = $('ref:mapSidebar'),
					isScrolled = '-is-scrolled';

				if (! $sidebar.hasClass(isScrolled) && $locations.scrollTop() > 1) {
					$sidebar.addClass(isScrolled);
				}

				Ps.update($locations[0]);

				scope.scrolled = false;
			}
		}, 200);
	},

	/**
	 * Highlight location
	 *
	 * @private
	 * @param {string} id
	 */
	highlightLocation: function(id) {
		this.locationsApp.$set('active', id);

		if ($.screen.size() > 2) {
			this.scrollToTop(
				$('ref:mapLocation').filter('ref:mapLocationId-' + id)
					.position()
					.top
			);

			Ps.update($('ref:mapLocations')[0]);
		}
	},

	/**
	 * Scroll locations to the top
	 *
	 * @private
	 * @param {number} position
	 */
	scrollToTop: function(position) {
		var $locations = $('ref:mapLocations');

		$.animate.tween('ref:mapLocations', {
			scrollTop: position
		});

		$locations.scrollTop(position);

		Ps.update($locations[0]);
	}
});